import { render, staticRenderFns } from "./FAQConfig.vue?vue&type=template&id=7cd21639&"
import script from "./FAQConfig.vue?vue&type=script&lang=js&"
export * from "./FAQConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports